<template>
  
  <div id="modal-ter" class="modal " :class="{'is-active': showModal}" >
      
      <div class="modal-background"></div>
        <div class="modal-card" style="width:900px">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ order.ponumber}} 
            <button class="button is-small is-link" style="margin-top:-5px" :disabled="working==true" v-if="order.embroidery_processed == 1 && order.embroidery_approved == 0" @click="approveOrder(order)">Click To Approve Embroidery</button>
            <button class="button is-small is-success" style="margin-top:-5px" :disabled="working==true"  v-if="order.embroidery_approved == 1">APPROVED</button>
            </p>
            <button class="delete" aria-label="close" @click="closeModal()"></button>
          </header>
          <section class="modal-card-body">
            <div class="content" ref="content" v-if="this.showAddToDesign == true">
                <h3 class="title is-size-4">Add Trex Code To Design</h3>
                <form @submit.prevent="saveDesignTrexCode()">
                    <div class="field" >
                        <div class="control">
                            <button class="button is-fullwidth" type="button" :class="{'is-danger' : this.not_approved == true}" @click="updateNotApproved()">Click Here To State That The TREX Code Is Not Yet Approved <span v-if="this.not_approved == true" class="ml-2"> ( SELECTED ) </span></button>
                        </div>
                    </div>
                    <div v-if="this.not_approved == false">
                        <div class="field">
                            <label class="label">Is This For Branding ?</label>
                            <div class="control">
                                <div class="select is-fullwidth">
                                <select class="is-fullwidth" required v-model="branding" >
                                    <option value="">Please select ...</option>
                                    <option  value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>
                                </div>
                            </div>
                        </div>
                        <div class="field" v-if="branding==='true'">
                            <label class="label">Branding TREX Code</label>
                            <div class="control">
                                <div class="select is-fullwidth">
                                <select class="is-fullwidth" v-model="trex_code" @change="checkTrexCode()">
                                    <option value="">Loading ...</option>
                                    <option v-for="row in branding_trex_codes" :key="row.id" :value="row.name">{{ row.name }}</option>
                                    
                                </select>
                                </div>
                            </div>
                        </div>
                        <div class="field" v-if="branding==='false'" >
                            <label class="label">Trex Code</label>
                            <div class="control">
                                <input class="input" type="text" v-model="trex_code" required @change="checkTrexCode()">
                            </div>
                        </div>
                        
                        <div class="notification is-warning" v-if="branding==='false' && trex_valid === false">
                            That trex code cannot be found in the database, so a new one will be created. Please enter the stitch count.
                        </div>
                        <div class="field" v-if="branding ==='false' && trex_valid === false">
                            <label class="label">Stitch Count</label>
                            <div class="control">
                                <input class="input" type="text" v-model="stitch_count" required>
                            </div>
                        </div>
                        <div class="field" v-if=" trex_valid === true ">
                            <label class="label">Stitch Count</label>
                            <div class="control">
                                <input class="input" type="text" disabled readonly v-model="stitch_count" >
                            </div>
                        </div>
                    </div>
                    
                    <div class="field">
                        <label class="label">Is This A Badge ?</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select class="is-fullwidth" required v-model="badge" >
                                <option value="">Please select ...</option>
                                <option  value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                            </div>
                        </div>
                    </div>
                    
                    <div class="field">
                        <label class="label">Type</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select class="is-fullwidth" required v-model="type_id">
                                <option value="4">Mens</option>
                                <option value="1">Mens & 13/14</option>
                                <option  value="2">Ladies</option>
                                <option value="3">Children 10/11 and Down</option>
                                <option  value="5">Kids</option>
                                <option  value="6">Kids Sizes 7/8 and Below</option>
                                <option  value="8">Kids 9-10</option>
                                <option  value="9">Kids 11-12</option>
                                <option  value="7">All Sizes</option>
                            </select>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Position</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select class="is-fullwidth" required v-model="position" >
                                <option value="">Please select ...</option>
                                <option  :value="row.name" v-for="row in positions" :key="row.id">{{ row.name }}</option>
                               
                            </select>
                        </div>
                        </div>
                    </div>
                    <div class="field is-grouped">
                        <div class="control">
                            <button type="submit" class="button is-link" :disabled="working==true">Save</button>
                        </div>
                        
                    </div>
                </form>
            </div>

            <div class="content" ref="content" v-if="this.showAddToOrder == true">
                <h3 class="title is-size-4">Add Trex Code To Order</h3>
                <form @submit.prevent="saveOrderTrexCode()">
                    <div class="field" >
                        <div class="control">
                            <button class="button is-fullwidth" type="button" :class="{'is-danger' : this.not_approved == true}" @click="updateNotApproved()">Click Here To State That The TREX Code Is Not Yet Approved <span v-if="this.not_approved == true" class="ml-2"> ( SELECTED ) </span></button>
                        </div>
                    </div>
                    <div v-if="this.not_approved == false">
                        <div class="field">
                            <label class="label">Is This For Branding ?</label>
                            <div class="control">
                                <div class="select is-fullwidth">
                                <select class="is-fullwidth" required v-model="branding" >
                                    <option value="">Please select ...</option>
                                    <option  value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>
                                </div>
                            </div>
                        </div>
                        <div class="field" v-if="branding=='true'">
                            <label class="label">Branding TREX Code</label>
                            <div class="control">
                                <div class="select is-fullwidth">
                                <select class="is-fullwidth" v-model="trex_code" @change="checkTrexCode()">
                                    <option value="">Loading ...</option>
                                    <option v-for="row in branding_trex_codes" :key="row.id" :value="row.name">{{ row.name }}</option>
                                    
                                </select>
                                </div>
                            </div>
                        </div>
                        <div class="field" v-if="branding=='false' " >
                            <label class="label">Trex Code</label>
                            <div class="control">
                                <input class="input" type="text" v-model="trex_code" required @change="checkTrexCode()">
                            </div>
                        </div>
                        
                        
                        <div class="notification is-warning" v-if="branding=='false' && trex_valid === false">
                            That trex code cannot be found in the database, so a new one will be created. Please enter the stitch count.
                        </div>
                        <div class="field" v-if="branding == 'false' && trex_valid === false">
                            <label class="label">Stitch Count</label>
                            <div class="control">
                                <input class="input" type="text" v-model="stitch_count" required>
                            </div>
                        </div>
                        <div class="field" v-if=" trex_valid === true ">
                            <label class="label">Stitch Count</label>
                            <div class="control">
                                <input class="input" type="text" disabled readonly v-model="stitch_count" >
                            </div>
                        </div>
                    </div>

                    

                    <div class="field">
                        <label class="label">Is This A Badge ?</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select class="is-fullwidth" required v-model="badge" >
                                <option value="">Please select ...</option>
                                <option  value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Type</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select class="is-fullwidth" required v-model="type_id">
                                <option value="4">Mens</option>
                                <option value="1">Mens & 13/14</option>
                                <option  value="2">Ladies</option>
                                <option value="3">Children 10/11 and down</option>
                                <option  value="5">Kids</option>
                                <option  value="6">Kids Sizes 7/8 and Below</option>
                                <option  value="8">Kids 9-10</option>
                                <option  value="9">Kids 11-12</option>
                                <option  value="7">All Sizes</option>
                            </select>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Position</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select class="is-fullwidth" required v-model="position" >
                                <option value="">Please select ...</option>
                                <option  :value="row.name" v-for="row in positions" :key="row.id">{{ row.name }}</option>
                               
                            </select>
                        </div>
                        </div>
                    </div>
                    <div class="control">
                        <button type="submit" class="button is-success" :disabled="working==true">Save</button>
                        <button type="button" class="button is-danger is-pulled-right" :disabled="working==true" @click="hideInitialsForm()">Back without Saving</button>
                    </div>
                </form>
            </div>

            <div class="content" ref="content" v-if="this.showOrderTrexCodeEdit == true">
                <h3 class="title is-size-4">Edit Trex Code Details</h3>
                <form @submit.prevent="updateOrderTrexCode()">
                    <div class="field" >
                        <div class="control">
                            <button class="button is-fullwidth" type="button" :class="{'is-danger' : this.not_approved == true}" @click="updateNotApproved()">Click Here To State That The TREX Code Is Not Yet Approved <span v-if="this.not_approved == true" class="ml-2"> ( SELECTED ) </span></button>
                        </div>
                    </div>
                    <div v-if="this.not_approved == false">
                        <div class="field">
                            <label class="label">Is This For Branding ?</label>
                            <div class="control">
                                <div class="select is-fullwidth">
                                <select class="is-fullwidth" required v-model="branding" >
                                    <option value="">Please select ...</option>
                                    <option  value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>
                                </div>
                            </div>
                        </div>
                        <div class="field" v-if="branding=='true'">
                            <label class="label">Branding TREX Code</label>
                            <div class="control">
                                <div class="select is-fullwidth">
                                <select class="is-fullwidth" v-model="trex_code" @change="checkTrexCode()">
                                    <option value="">Loading ...</option>
                                    <option v-for="row in branding_trex_codes" :key="row.id" :value="row.name">{{ row.name }}</option>
                                    
                                </select>
                                </div>
                            </div>
                        </div>
                        <div class="field" v-if="branding=='false' || branding==''" >
                            <label class="label">Trex Code</label>
                            <div class="control">
                                <input class="input" type="text" v-model="trex_code" required @change="checkTrexCode()">
                            </div>
                        </div>
                        
                        
                        <div class="notification is-warning" v-if="branding=='false' && trex_valid === false">
                            That trex code cannot be found in the database, so a new one will be created. Please enter the stitch count.
                        </div>
                        <div class="field" v-if="branding =='false' && trex_valid === false">
                            <label class="label">Stitch Count</label>
                            <div class="control">
                                <input class="input" type="text" v-model="stitch_count" required>
                            </div>
                        </div>
                        <div class="field" v-if=" trex_valid === true ">
                            <label class="label">Stitch Count</label>
                            <div class="control">
                                <input class="input" type="text" disabled readonly v-model="stitch_count" >
                            </div>
                        </div>
                    </div>

                    

                    <div class="field">
                        <label class="label">Is This A Badge ?</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select class="is-fullwidth" required v-model="badge" >
                                <option value="">Please select ...</option>
                                <option  value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Type</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select class="is-fullwidth" required v-model="type_id">
                                <option value="4">Mens</option>
                                <option value="1">Mens & 13/14</option>
                                <option  value="2">Ladies</option>
                                <option value="3">Children 10/11 and down</option>
                                <option  value="5">Kids</option>
                                <option  value="6">Kids Sizes 7/8 and Below</option>
                                <option  value="8">Kids 9-10</option>
                                <option  value="9">Kids 11-12</option>
                                <option  value="7">All Sizes</option>
                            </select>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Position</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select class="is-fullwidth" required v-model="position" >
                                <option value="">Please select ...</option>
                                <option  :value="row.name" v-for="row in positions" :key="row.id">{{ row.name }}</option>
                               
                            </select>
                        </div>
                        </div>
                    </div>
                    <div class="field ">
                        <div class="control">
                            <button type="submit" class="button is-link" :disabled="working==true">Update</button>
                            <button type="button" class="button is-danger is-pulled-right" :disabled="working==true" @click="hideInitialsForm()">Back without Saving</button>
                        </div>
                        
                    </div>
                </form>
            </div>

            <div class="content" ref="content" v-if="this.showInitials == true">
                <h3 class="title is-size-4">Add Initials To Order</h3>
                <form @submit.prevent="saveOrderInitials()">
                    <div class="field">
                        <label class="label">Number of Garments</label>
                        <div class="control">
                            <input class="input" type="number" v-model="quantity" required>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Stitch Count</label>
                        <div class="control">
                            <input class="input" type="number" v-model="num_stitches" required>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Position</label>
                        <div class="control">
                            <input class="input" type="text" v-model="position" required>
                        </div>
                    </div>
                   
                    <div class="field ">
                        <div class="control">
                            <button type="submit" class="button is-link" :disabled="working==true">Save</button>
                            <button type="button" class="button is-danger is-pulled-right" :disabled="working==true" @click="hideInitialsForm()">Back without Saving</button>
                        </div>
                        
                    </div>
                </form>
            </div>

            <div class="content" ref="content" v-if="this.showInitialsEdit == true">
                <h3 class="title is-size-4">Edit Initial Details</h3>
                <form @submit.prevent="updateOrderInitials()" v-if="this.loading_initials == false">
                    <div class="field">
                        <label class="label">Number of Garments</label>
                        <div class="control">
                            <input class="input" type="number" v-model="quantity" required>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Stitch Count</label>
                        <div class="control">
                            <input class="input" type="number" v-model="num_stitches" required>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">Position</label>
                        <div class="control">
                            <input class="input" type="text" v-model="position" required>
                        </div>
                    </div>
                   
                    <div class="field ">
                        <div class="control">
                            <button type="submit" class="button is-link" :disabled="working==true">Update</button>
                            <button type="button" class="button is-danger is-pulled-right" :disabled="working==true" @click="hideInitialsForm()">Back without Saving</button>
                        </div>
                        
                    </div>
                </form>
                <div class="notification is-warning" v-if="this.loading_initials == true">
                    Loading details of saved initials
                </div>
            </div>
            
            <div class="content" ref="content" v-if="this.showSummary == true">
                <h3 class="title">Design</h3>
                <table class="table is-fullwidth is-size-7" v-if="this.orderID > 0 && this.loading == false && order.design_trex_codes.length > 0">
                    <tr>
                        <th>Trex Code</th>
                        <th>Position</th>
                        <th>Size</th>
                        <th>Stitches</th>
                        <th style="display:none">Cost</th>
                    </tr>

                    <tr v-for="row in order.design_trex_codes" :key="row.id">
                        <td>{{ row.name }} 
                            <span class="tag is-success" v-if="row.badge==1">Badge</span> 
                            <span class="tag is-warning" v-if="row.branding==1">Branding</span> 
                            <span class="tag is-danger" v-if="row.not_approved==1">NOT Approved</span>
                        </td>
                        <td>{{ row.position }}</td>
                        <td>{{ row.size_name }}</td>
                        <td>{{ row.num_stitches}}</td>
                        <td style="display:none">{{ row.num_stitches * cost_per_stitch}}</td>
                    </tr>

                </table>
                <div class="notification is-warning" v-if="this.orderID > 0 && this.loading == false && order.design_trex_codes.length == 0">
                    There are no trex codes linked to this design yet
                </div>
                <button class="button is-small is-success mb-2" @click="showNewDesignForm()" v-if="showAddButtons==true">Add New Trex Code To Design</button>

                <h3 class="title">Order</h3>
                <table class="table is-fullwidth is-size-7" v-if="this.orderID > 0 && this.loading == false && order.order_trex_codes.length > 0">
                    <tr>
                        <th>Trex Code</th>
                        <th>Position</th>
                        <th>Size</th>
                        <th>Stitches</th>
                        <th style="display:none">Cost</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                    <tr v-for="row in order.order_trex_codes" :key="row.id">
                        <td :title="'Added/Updated on ' + row.updated_at_date ">{{ row.name }} 
                            <span class="tag is-success" v-if="row.badge==1">Badge</span> 
                            <span class="tag is-warning" v-if="row.branding==1">Branding</span> 
                            <span class="tag is-danger" v-if="row.not_approved==1">NOT Approved</span>
                        </td>
                        <td>{{ row.position }}</td>
                        <td>{{ row.size_name }}</td>
                        <td>{{ row.num_stitches}}</td>
                        <td style="display:none">{{ row.num_stitches * cost_per_stitch}}</td>
                        <td>
                            <button class="button is-small is-link" @click="showOrderTrexCodeEditForm(row.id)" v-if="showAddButtons==true">Edit</button>
                        </td>
                        <td>
                            <button class="button is-small is-danger" @click="deleteOrderTrexCode(row.id)" v-if="showAddButtons==true">Delete </button>
                        </td>
                    </tr>
                </table>
                <div class="notification is-warning" v-if="this.orderID > 0 && this.loading == false && order.order_trex_codes.length == 0">
                    There are no trex codes linked to this order yet
                </div>
                <button class="button is-small is-success mb-2" @click="showNewOrderForm()" v-if="showAddButtons==true">Add New Trex Code To Order</button>
 
                <h3 class="title">Initials For Order</h3>
                <table class="table is-fullwidth is-size-7" v-if="this.orderID > 0 && this.loading == false && order.order_initials.length > 0">
                    <tr>
                        <th>Garments</th>
                        <th>Position</th>
                        <th>Stitch Count</th>
                        <th >Total Stitches</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                    <tr v-for="row in order.order_initials" :key="row.id">
                        <td>{{ row.quantity }}</td>
                        <td>{{ row.position }}</td>
                        <td>{{ row.num_stitches}}</td>
                        <td >{{ row.quantity * row.num_stitches }}</td>
                        <td>
                            <button class="button is-small is-link" @click="showInitialsEditForm(row.id)" v-if="showAddButtons==true">Edit</button>
                        </td>
                        <td>
                            <button class="button is-small is-danger" @click="deleteOrderInitials(row.id)" v-if="showAddButtons==true">Delete</button>
                        </td>
                    </tr>

                </table>
                <div class="notification is-warning" v-if="this.orderID > 0 && this.loading == false && order.order_initials.length == 0">
                    There are no initials linked to this order yet
                </div>
                <button class="button is-small is-success mb-2" @click="showInitialsForm()" v-if="showAddButtons==true">Add Initials To Order</button>

                <h3 class="title">Embroidery to be Applied in Strabane</h3>
                <div v-if="this.loading == false && order.embroidery_requests_strabane.length > 0">
                    <div v-for="item in order.embroidery_requests_strabane" :key="item.id">
                        <div class="field">
                            <textarea class="textarea" placeholder="Add details of any embroidery to be applied in Strabane" rows="2" v-model="item.text"></textarea>
                            <small v-if="item.status==2"><em>This request has already been marked as complete in Strabane and cannot be updated</em><br /><br /></small>
                        </div>
                        <button class="button is-small is-link mb-2" @click="updateEmbroideryRequestStrabane(item)" v-if="item.status==1" :disabled="working==true">Update Request</button>
                        
                    </div>
                </div>
                <div v-else-if="this.loading == false && order.embroidery_requests_strabane.length == 0">
                    <div class="field">
                        <textarea class="textarea" placeholder="Add details of any embroidery to be applied in Strabane" rows="2" v-model="embroidery_request_text"></textarea>
                    </div>
                    <button class="button is-small is-success mb-2" @click="saveEmbroideryRequestStrabane()" :disabled="working==true">Save New Request</button>
                </div>
                
              
            </div>
          </section>
          <footer class="modal-card-foot">
            
            <button class="button" @click="closeModal()">Close</button>
          </footer>
        </div>

        
        
    </div>

</template>

<script>
import UtilityService from '@/services/UtilityService.js';
import OrderService from '@/services/OrderService.js';

export default {
  data() {
    return {
      order: [{order_trex_codes: [], design_trex_codes: [], order_initials: []}],
      showSummary: true,
      showAddToDesign : false,
      showAddToOrder: false,
      trex_code : 'TREX',
      stitch_count: '',
      showInitials: false,
      showInitialsEdit: false,
      showOrderTrexCodeEdit: false,
      quantity: '',
      num_stitches: '',
      trex_code_id: '',
      type_id: '',
      position: '',
      accessToken: '',
      loading: true,
      cost_per_stitch : 0.01,
      trex_codes: [],
      working: false,
      search_done : false,
      badge: '',
      branding: '',
      positions: [],
      branding_trex_codes: [],
      not_approved: false,
      order_initial_id: '',
      // For editing initials
      loading_initials: false,
      order_initials: [],
      order_trex_code_id : '',
        loading_order_trex_code: false,
        order_trex_code: [],
        embroidery_request_text: ''
    }
  },
  props: {
    showModal: Boolean,
    orderID: Number,
    showAddButtons: Boolean
  },
  
  methods: {
    updateNotApproved() {
        if(this.not_approved == true)
        {
            this.not_approved = false
            this.trex_code = ''
        }
        else {
            this.not_approved = true
            this.trex_code = 'NOT_APPROVED'
        }
    },
    closeModal() {
        this.showSummary = true;
        this.showAddToDesign = false;
        this.showInitials = false;
        this.showInitialsEdit = false;
        this.showOrderTrexCodeEdit = false;
        this.trex_code = 'TREX'
        this.stitch_count = ''
        this.position = ''
        this.type_id = ''
        this.badge = ''
        this.branding=''
        this.not_approved = false
        this.$emit('closeModal')
    },
    async getOrder() {
        this.search_done = false
        this.trex_codes = []
        if(this.orderID > 0)
        {
            this.loading = true
            UtilityService.getSimpleApiData(this.accessToken, "orders/" + this.orderID + "?include_embroidery=1").then(
                (response => {
                    this.$set(this, "order", response);
                    this.loading=false
                   
                }).bind(this)
                
            );
        }
    },
    async checkTrexCode()
    {
        this.working = true
        
        // Lookup the code
        UtilityService.getSimpleApiData(this.accessToken, "trex_codes?search=" + this.trex_code).then(
            (response => {
                this.$set(this, "trex_codes", response);
                this.working=false
                this.search_done = true

                if(this.trex_codes.length > 0)
                {
                    this.stitch_count = this.trex_codes[0].num_stitches
                }
            }).bind(this)
        );

    },
    async getTrexCodes() {
        
        UtilityService.getSimpleApiData(this.accessToken, "trex_codes?branding=1").then(
            (response => {
                this.$set(this, "branding_trex_codes", response);
                this.loading=false
                
            }).bind(this)
            
        );
        
    },
    async getEmbroideryPositions() {
        
        UtilityService.getSimpleApiData(this.accessToken, "embroidery_positions").then(
            (response => {
                this.$set(this, "positions", response);
                this.loading=false
                
            }).bind(this)
            
        );
        
    },
    showNewDesignForm() {
        this.showSummary = false;
        this.showAddToDesign = true;
        this.showAddToOrder = false;
        this.showInitials = false;
        this.showInitialsEdit = false;
        this.showOrderTrexCodeEdit = false;
    },
    showNewOrderForm() {
        this.showSummary = false;
        this.showAddToDesign = false;
        this.showAddToOrder = true;
        this.showInitials = false;
        this.showInitialsEdit = false;
        this.showOrderTrexCodeEdit = false;
    },
    showInitialsForm() {
        this.showSummary = false;
        this.showAddToDesign = false;
        this.showAddToOrder = false;
        this.showInitials = true;
        this.showInitialsEdit = false;
        this.showOrderTrexCodeEdit = false;
    },
    showInitialsEditForm(id) {
        this.order_initial_id = id
        this.loading_initials = true

        // Get the details of this Order Initials and populate the form
        this.getOrderInitials(this.order_initial_id)

        this.showSummary = false;
        this.showAddToDesign = false;
        this.showAddToOrder = false;
        this.showInitials = false;
        this.showInitialsEdit = true;
        this.showOrderTrexCodeEdit = true;
    },
    showOrderTrexCodeEditForm(id) {
        this.order_trex_code_id = id
        this.loading_order_trex_code = true

        // Get the details of this Order Initials and populate the form
        this.getOrderTrexCode(this.order_trex_code_id)
        

        this.showSummary = false;
        this.showAddToDesign = false;
        this.showAddToOrder = false;
        this.showInitials = false;
        this.showInitialsEdit = false;
        this.showOrderTrexCodeEdit = true;
        
    },
    hideInitialsForm() {
        this.showSummary = true;
        this.showAddToDesign = false;
        this.showAddToOrder = false;
        this.showInitials = false;
        this.showInitialsEdit = false;
        this.showOrderTrexCodeEdit = false;
    },
    showSummaryScreen() {
        this.showSummary = true;
        this.showAddToDesign = false;
        this.showAddToOrder = false;
        this.showInitials = false;
        this.showInitialsEdit = false;
        this.showOrderTrexCodeEdit = false;

        // Clear the forms
        this.quantity = '';
        this.num_stitches = ''
        this.position = ''
        this.branding = ''
        this.badge = ''
        this.not_approved = false
    },
    
    
    async saveDesignTrexCode() {
        this.working = true
        var formdata = { 
            trex_code : this.trex_code,
            num_stitches : this.stitch_count,
            design_id : this.order.designID,
            type_id : this.type_id,
            position : this.position,
            badge: this.badge,
            not_approved: this.not_approved
            
        }; 

        OrderService.saveDesignTrexCode(this.accessToken, formdata)
        .then((response) => {
            console.log(response)
            this.getOrder();

            this.trex_code = 'TREX'
            this.stitch_count = ''
            this.position = ''
            this.type_id = ''
            this.badge = ''
            this.branding=''
            this.not_approved = false

            this.showSummaryScreen();
            
            this.working = false
            
            }).catch((error) => {
                if(error.response.status === 422)
                {
                    console.log("Error:" + JSON.stringify(error.response.data));
                }
                alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                this.working = false
        });
    },
    async saveOrderTrexCode() {
        this.working = true
        var formdata = { 
            trex_code : this.trex_code,
            num_stitches : this.stitch_count,
            order_id : this.order.orderID,
            type_id : this.type_id,
            branding : this.branding,
            position : this.position,
            badge: this.badge,
            not_approved: this.not_approved
            
        }; 

        OrderService.saveOrderTrexCode(this.accessToken, formdata)
        .then((response) => {
            console.log(response)
            this.getOrder();

            this.trex_code = 'TREX'
        this.stitch_count = ''
        this.position = ''
        this.type_id = ''
        this.badge = ''
        this.branding=''
        this.not_approved = false

            this.showSummaryScreen();
            
            this.working = false
            
            }).catch((error) => {
                if(error.response.status === 422)
                {
                    console.log("Error:" + JSON.stringify(error.response.data));
                }
                alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                this.working = false
        });
    },
    async saveOrderInitials() {
        this.working = true
        var formdata = { 
             order_id : this.order.orderID,
            num_stitches : this.num_stitches,
            quantity : this.quantity,
            position : this.position
            
        }; 

        OrderService.saveOrderInitials(this.accessToken, formdata)
        .then((response) => {
            console.log(response)
            this.getOrder();
            this.showSummaryScreen();
            
            this.working = false
            
            }).catch((error) => {
                if(error.response.status === 422)
                {
                    console.log("Error:" + JSON.stringify(error.response.data));
                }
                alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                this.working = false
        });
    },
    async updateOrderInitials() {
        this.working = true

        var formdata = { 
            _method: 'patch',
           num_stitches : this.num_stitches,
            quantity : this.quantity,
            position : this.position
            
        }; 

        OrderService.updateOrderInitials(this.accessToken, formdata, this.order_initial_id)
        .then((response) => {
            console.log(response)
            this.getOrder();
            this.showSummaryScreen();
            
            this.working = false
            
            }).catch((error) => {
                if(error.response.status === 422)
                {
                    console.log("Error:" + JSON.stringify(error.response.data));
                }
                alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                this.working = false
        });
        this.working = false
    },
    async updateOrderTrexCode() {
        this.working = true

        var formdata = { 
            _method: 'patch',
            trex_code : this.trex_code,
            num_stitches : this.stitch_count,
            type_id : this.type_id,
            branding : this.branding,
            position : this.position,
            badge: this.badge,
            not_approved: this.not_approved
            
        }; 

        OrderService.updateOrderTrexCode(this.accessToken, formdata, this.order_trex_code_id)
            .then((response) => {
                console.log(response)
                this.getOrder();

                this.trex_code = 'TREX'
            this.stitch_count = ''
            this.position = ''
            this.type_id = ''
            this.badge = ''
            this.branding=''
            this.not_approved = false

                this.showSummaryScreen();
                
                this.working = false
                
                }).catch((error) => {
                    if(error.response.status === 422)
                    {
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                    this.working = false
            });
        this.working = false
    },
    async deleteOrderInitials(order_initial_id) {
        this.working = true

        if(confirm('Are you sure you want to delete these Initials ?'))
        {
            var formdata = { 
                _method: 'patch',
                active : 0,
            
            }; 

            OrderService.updateOrderInitials(this.accessToken, formdata, order_initial_id)
            .then((response) => {
                console.log(response)
                this.getOrder();
                //this.showSummaryScreen();
                
                this.working = false
                
                }).catch((error) => {
                    if(error.response.status === 422)
                    {
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                    this.working = false
            });
            this.working = false
        }
        else {
            this.working = false
        }
    },
    async deleteOrderTrexCode(order_trex_code_id) {
        this.working = true

        if(confirm('Are you sure you want to delete this Trex Code ?'))
        {
            var formdata = { 
                _method: 'patch',
                active : 0,
            }; 

            OrderService.updateOrderTrexCode(this.accessToken, formdata, order_trex_code_id)
            .then((response) => {
                console.log(response)
                this.getOrder();
                //this.showSummaryScreen();
                
                this.working = false
                
                }).catch((error) => {
                    if(error.response.status === 422)
                    {
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                    this.working = false
            });
            this.working = false
        }
        else {
            this.working = false
        }
    },
    async approveOrder(order) {
       
          this.working = true

          if(confirm("Are you sure you want to APPROVE this embroidery order ? "))
          {
            var formdata = { 
              _method: 'patch',
              embroidery_approved: 1
            }; 

            OrderService.updateOrder(this.accessToken, order.orderID, formdata)
              .then(() => {
              order.embroidery_approved = 1

              this.$emit('updateOrderApproved')

              this.working = false
              //console.log(response)
            }).catch((error) => {
              alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
            });
          }
          else{
            this.working = false
            return false
          }

          
        
      },
      async getOrderInitials (order_initial_id)
        {
            console.log("Loading Order Initials")
            this.loading_initials = true;
            UtilityService.getSimpleApiData(this.accessToken, "order_initials/" + order_initial_id).then(
                (response) => {
                    this.order_initials = response 
                    this.loading_initials = false

                    this.quantity = this.order_initials.quantity;
                    this.num_stitches = this.order_initials.num_stitches;
                    this.position = this.order_initials.position;
                    console.log("Order Initials loaded")
                }
            );
        },
        async getOrderTrexCode (order_trex_code_id)
        {
            console.log("Loading Order Trex Code Details")
            this.loading_order_trex_code = true;
            UtilityService.getSimpleApiData(this.accessToken, "order_trex_codes/" + order_trex_code_id).then(
                (response) => {
                    this.order_trex_code = response 
                    this.loading_order_trex_code = false

                    this.not_approved = this.order_trex_code.not_approved;
                    this.branding = this.order_trex_code.branding;
                    this.badge = this.order_trex_code.badge;
                    this.type_id = this.order_trex_code.type_id;
                    this.position = this.order_trex_code.position;
                    this.trex_code = this.order_trex_code.name;

                    this.checkTrexCode()

                    console.log("Order Trex Code Details loaded")
                }
            );
        },
        async saveEmbroideryRequestStrabane() {
            this.working = true
            var formdata = { 
                order_id : this.order.orderID,
                text : this.embroidery_request_text,
                
            }; 

            OrderService.saveEmbroideryRequestStrabane(this.accessToken, formdata)
            .then((response) => {
                console.log(response)
                this.getOrder();
                
                this.working = false
                
                }).catch((error) => {
                    if(error.response.status === 422)
                    {
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                    this.working = false
            });
        },
         async updateEmbroideryRequestStrabane(item) {
            this.working = true
            var formdata = { 
                _method: 'patch',
                text : item.text  ,
                status: 1 
            }; 

            OrderService.updateEmbroideryRequestStrabane(this.accessToken, item.id, formdata)
            .then((response) => {
                console.log(response)
                this.getOrder();
                
                this.working = false
                
                }).catch((error) => {
                    if(error.response.status === 422)
                    {
                        console.log("Error:" + JSON.stringify(error.response.data));
                    }
                    alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                    this.working = false
            });
        },
		
  },
  created() {
    this.getAccessToken()
        .then(() => { 
           this.getOrder();
          this.getTrexCodes();
          this.getEmbroideryPositions();
        });
  },
  mounted() {
    
    
  },
  watch: {
    'orderID'() {
        
        this.getOrder()
        
    }
  },
  computed: {
    trex_valid: function() {
        if(this.search_done == true && this.trex_codes.length > 0)
        {
            return true
        }
        else if(this.search_done == false)
        {
            return true
        }
        else{
            return false
        }
    }
  }
  

}
</script>

<style scoped>
  .column {padding-top:0;padding-bottom:0px}
  h3 {margin-top:10px !important}

</style>